import { put, takeEvery } from 'redux-saga/effects';
import { API } from '../../api/apiList';
import Axios from '../../config/AxiosConfig';
import * as type from '../actions/LanguageList';

function* LanguageData() {
    let apiDetails = API.find((API) => API.name === 'langauges');
    try {
        const response = yield Axios.get(apiDetails.listAPI).catch(Er => {
            throw (Er)
        })

        if (response && response.data) {
          yield put({ type: type.FETCH_LANGUAGE_SUCCESS, payload: response.data.data });
        }
    }
    catch (er) {
        yield put({ type: type.FETCH_LANGUAGE_ERROR, payload: er.toString() })
    }
}

export function* LanguageSaga() {
    yield takeEvery(type.FETCH_LANGUAGE_REQUEST, LanguageData)
}